/**
 * Runs an async task without blocking the caller. Rejections are caught and logged
 * so background refreshes (e.g. unread counts) do not surface as unhandled promise rejections.
 */
export const runFireAndForget = (task: () => Promise<void>, context = 'Async task'): void => {
    void task().catch((err: unknown) => {
        const message = err instanceof Error ? err.message : String(err);
        console.error(`${context} failed:`, message, err);
    });
};
